import { PC_BREAKPOINT } from 'shared/constants'
import css from 'styled-jsx/css'

export default css`
  .container {
    width: var(--screen-width);
    height: var(--screen-height);
    max-width: 480px;
    padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px)
      env(safe-area-inset-left, 0px);
    margin: 0 auto;
    position: relative;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }
  .content {
    flex: 1;
    overflow: auto;
  }
  .thumbnail {
    padding: 0 16px;
    width: 100%;
    margin-bottom: 24px;
  }
  .editor-content {
    margin: 0 16px;
    padding-bottom: 24px;
    word-wrap: break-word;

    :global(iframe) {
      max-width: 100%;
    }

    :global(img.full-width) {
      width: 100% !important;
      height: unset !important;
    }
    :global(table) {
      margin-top: 1em;
      margin-bottom: 1em;
    }
    :global(table tr td) {
      border: 1px solid #dadada;
      min-width: 2em;
      padding: 0.4em;
      -webkit-user-select: text;
      -moz-user-select: text;
      -ms-user-select: text;
      user-select: text;
      vertical-align: middle;
    }
  }
  .copy-link-button {
    margin: 0 16px 24px 16px;
    border-radius: 6px;
    padding: 6px 16px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
  .link-icon {
    width: 16px;
    height: 16px;
  }

  @media screen and (min-width: ${PC_BREAKPOINT}px) {
    .container {
      max-width: 960px;
    }
    .thumbnail {
      padding: 0 100px;
    }
    .editor-content {
      margin: 0 100px;
    }
  }
`
